import * as THREE from "three";
import * as perlin from "./lib/perlin"
// import {sceneConfig} from "./conf/config-prod"
import sceneConfig from "./conf/config-prod.js"

let renderer

var scene = new THREE.Scene();
var camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.z = 5;

const ambientLight = new THREE.AmbientLight(0x798296)
scene.add(ambientLight)
const directionalLight = new THREE.DirectionalLight(0xff0000, 0.5)
directionalLight.position.set(5, 10, 7)
scene.add(directionalLight);



// https://stackoverflow.com/questions/21710049/animated-gif-as-texture-in-three-js
// how to load gif as texture => first convert as mp4, then load as texture

const loadTextureVideo = (src) => {
  // Create video and play
  let textureVid = document.createElement("video")
  textureVid.src = src; // transform gif to mp4
  textureVid.loop = true;
  textureVid.muted = true;
  textureVid.play();


  // Load video texture
  let videoTexture = new THREE.VideoTexture(textureVid);
  videoTexture.format = THREE.RGBAFormat;
  videoTexture.minFilter = THREE.NearestFilter;
  videoTexture.maxFilter = THREE.NearestFilter;
  videoTexture.generateMipmaps = false;

  return videoTexture
}

const createMeshVideo = (s, videoTexture) => {
  // Create mesh
  var geometry = new THREE.SphereGeometry( 1, 1, 1 );
  var material = new THREE.MeshBasicMaterial( { map: videoTexture } );
  // mesh = new THREE.Mesh( geometry, material );
  // scene.add(mesh);
}

// transparent issue
// https://stackoverflow.com/questions/29456869/three-js-black-color-of-material-to-transparent 


sceneConfig.spheres.map(s => {
  s.sphere_geometry = new THREE.SphereGeometry(1.5, 128, 128);
  // s.material = new THREE.MeshMatcapMaterial({
  // // s.material = new THREE.MeshPhongMaterial({
  //   side: THREE.DoubleSide,
  //   transparent: true,
  //   // color: 0xffffff,
  //   // specular   : new THREE.Color("rgb(255,255,255)"),
  //   // shininess  : 0.1,                              
  //   // depthTest  : 0,
  //   // blending   : 1,

  //   // onBeforeCompile shader found here :
  //   //  https://discourse.threejs.org/t/trying-to-get-transparent-color-from-png-to-be-the-color-of-the-material/21681/9
  //   // onBeforeCompile: shader => {
  //   //   shader.fragmentShader = shader.fragmentShader.replace('#include <alphatest_fragment>', `
  //   //       if ( diffuseColor.a < ALPHATEST ) diffuseColor = vec4(vec3(0.733,0.733,0.733), 1.0);
  //   //   `);
  //   // }
  // });
  const texture = new THREE.TextureLoader().load(s.matcapTextureImg);
  texture.format = THREE.RGBAFormat

  // s.material = new THREE.MeshPhongMaterial({ // color inversée ?
  // s.material = new THREE.MeshStandardMaterial({ // couleur inversée ?
  // s.material = new THREE.MeshBasicMaterial({ // couleur normale
  // s.material = new THREE.MeshDepthMaterial({ // tout noir..
  // s.material = new THREE.MeshDistanceMaterial({ // tout blanc..
  // s.material = new THREE.MeshLambertMaterial({ // trans + couleur inverse
  // s.material = new THREE.MeshMatcapMaterial({ // trans + couleur inverse
  // s.material = new THREE.MeshNormalMaterial({ // aucun material mais belle couleur violette :)
  // s.material = new THREE.MeshPhongMaterial({ // aucun material mais belle couleur violette :)
  // s.material = new THREE.MeshPhysicalMaterial({ 
  // s.material = new THREE.MeshStandardMaterial({ 
  s.material = new THREE.MeshToonMaterial({ // genre de orange pas dégueu 
    map: texture,
    // matcap: texture,
    // transparent: true,
      alphaTest: 1,
      color: 0xffffff,
      // specular: 0xffffff,
      reflectivity: 0.3,
      side: THREE.DoubleSide, 
      // onBeforeCompile: shader => {
      //     shader.fragmentShader = shader.fragmentShader.replace('#include <alphatest_fragment>', `
      //         if ( diffuseColor.a < ALPHATEST ) diffuseColor = vec4(vec3(0.733,0.733,0.733), 1.0);
      //     `);
      // }
  });

  // s.material.color = THREE.Color(0xffffff)
  // if(s.matcapTextureImg) {
  //   s.matcapTexture = new THREE.TextureLoader().load(s.matcapTextureImg);
  //   s.matcapTexture.format = THREE.RGBAFormat
  //   // s.material.matcap = s.matcapTexture;
  //   // s.material.transparent = true
  // }
  // if(s.matcapTextureVideo) {
  //   const videoTexture = loadTextureVideo(s.matcapTextureVideo)
  //   s.material = new THREE.MeshBasicMaterial( { map: videoTexture } );
  // }
  s.sphere = new THREE.Mesh(s.sphere_geometry, s.material);
  s.sphere.geometry.attributes.position.needsUpdate = true;
  scene.add(s.sphere)
})

// var sphere_geometry = new THREE.SphereGeometry(1.5, 128, 128);
// var sphere_geometry2 = new THREE.SphereGeometry(1.5, 128, 128);
// var sphere_geometry3 = new THREE.SphereGeometry(1.5, 128, 128);

// var material = new THREE.MeshMatcapMaterial();
// var material2 = new THREE.MeshMatcapMaterial();
// var material3 = new THREE.MeshMatcapMaterial();

// let matcapTexture
// let matcapTexture2
// let matcapTexture3

// matcapTexture = new THREE.TextureLoader().load('freepik/11.png') // yes  => beau bleu, a retravailler un peu pour choper le bleu avatar copeau
// matcapTexture2 = new THREE.TextureLoader().load('freepik/v904-nunny-022.jpg') // yes
// matcapTexture3 = new THREE.TextureLoader().load('perso/blanc.png') // m

// material.matcap = matcapTexture
// material2.matcap = matcapTexture2
// material3.matcap = matcapTexture3


// var sphere = new THREE.Mesh(sphere_geometry, material);
// var sphere2 = new THREE.Mesh(sphere_geometry2, material2);
// var sphere3 = new THREE.Mesh(sphere_geometry3, material3);

// sphere.geometry.attributes.position.needsUpdate = true;
// sphere2.geometry.attributes.position.needsUpdate = true;
// sphere3.geometry.attributes.position.needsUpdate = true;


// scene.add(sphere);
// scene.add(sphere2);
// scene.add(sphere3);




var update = function ({sphere, speed, k, mul}) {
  var time = performance.now() * speed;

  var p = new THREE.Vector3();   
  const positions = sphere.geometry.attributes.position;

  for (var i = 0; i < positions.count; i++) {
    p.fromBufferAttribute(positions, i)
    p.normalize().multiplyScalar(
      1 + mul * noise.perlin3(p.x * k + time, p.y * k, p.z * k)
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }

  positions.needsUpdate = true;
  sphere.geometry.computeVertexNormals(); 
};


function animate() {
  // sphere.rotation.x += 0.0001;
  // sphere.rotation.y += 0.0001;
  sceneConfig.spheres.map(s => update({
    k: s.perlin.k,
    mul: s.perlin.mul,
    speed: s.perlin.speed,
    sphere: s.sphere,
  }))
  // update();
  // update2();
  // update3();
  /* render scene and camera */
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
}

const resize = () => {
  renderer.setSize(window.innerWidth, window.innerHeight)
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};

export const createScene = (el) => {
  renderer = new THREE.WebGLRenderer({ antialias: true, canvas: el, 
    // preserveDrawingBuffer: true  // could have perf implications
  });
  // renderer.setClearColor(0xffffff);
  renderer.setClearColor(0xfafafa);
  //  use device aspect ratio //
  renderer.setPixelRatio(window.devicePixelRatio);
  // set size of canvas within window //
  renderer.setSize(window.innerWidth, window.innerHeight);
  resize();
  animate();
}

window.addEventListener('resize', resize);

// requestAnimationFrame(animate);
export {
  animate,
  renderer,
}
